import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { Title } from '@angular/platform-browser';
import { ProviderService as Service} from '../core/models/provider-service.model';
import { Provider } from '../core/models/provider.model';

import { ProviderService as ProviderService } from '../core/services/provider.service';

import { ServiceDetailService } from '../core/services/service-detail.service';

import { HttpClientModule } from '@angular/common/http';

//import { NewCartService } from '../core/services/new-cart.service';

import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, combineLatest, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';
import { map, flatMap, tap, switchMap, switchAll, take, filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CartService } from '../core/services/cart.service';

@Component({
  selector: 'app-field',
  templateUrl: './field.page.html',
  styleUrls: ['./field.page.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, SharedModule, HttpClientModule],
  providers: [ ServiceDetailService, ProviderService ]
})
export class FieldPage implements OnInit {

  service$: Observable<Service>;
  provider$: Observable<Provider>;

  currentFieldSlug: string | null = null;

  constructor(
    private titleService: Title,
    private providerService: ProviderService,
    private route: ActivatedRoute,
    private serviceDetailService: ServiceDetailService,
    public cartService: CartService

  ) {

    const capitalizeFirstLetter = function(text: string): string {
      if (!text) return text;
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }


      this.service$ = this.serviceDetailService.getServiceByPageRoute$( this.route.paramMap ).pipe(
        tap( field => this.titleService.setTitle( capitalizeFirstLetter(field.name) + ' | dm Studio') )
      );

      this.provider$ = this.providerService.getProvider$();
  }

  ngOnInit() {
  }

  getAvatarUrl(file: string): string {
    return environment.docsUrl + '/' + file;
  }

}
